import { render, staticRenderFns } from "./OrgaoForm.vue?vue&type=template&id=54dd4436&scoped=true&"
import script from "./OrgaoForm.vue?vue&type=script&lang=js&"
export * from "./OrgaoForm.vue?vue&type=script&lang=js&"
import style0 from "./OrgaoForm.vue?vue&type=style&index=0&id=54dd4436&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "54dd4436",
  null
  
)

export default component.exports